export default Object.freeze({
  ACCESS_LEVELS: {
    USER: 10,
    AADE: 100,
    MASTER: 1000,
  },
  NO_TRANSMISSION_FAILURE_TEXT: "Άμεση Διαβίβαση",
  TRANSMISSION_FAILURE_1_TEXT: "Απώλεια Διασύνδεσης Επιχείρησης – Παρόχου - Transmission Failure_1",
  TRANSMISSION_FAILURE_2_TEXT: "Απώλεια Διασύνδεσης Παρόχου – ΑΑΔΕ - Transmission Failure_2",
});
